module.exports = __webpack_public_path__ + "img/fruit-bananas-190x100.80f8b319.jpg";